import { useMutation } from '@apollo/client';
import { generatePath } from 'react-router';

import {
  accountFormToGraphql,
  accountGraphqlToForm,
} from '../../../app/data/accountConversions';
import {
  ACCOUNT_QUERY,
  UPDATE_ACCOUNT_MUTATION,
} from '../../../app/graphql/accountQueries';
import routes from '../../../app/routes';
import AdminConsoleDetail from '../common/AdminConsoleDetail';
import AdminAccountProfileCard from './detail/AdminAccountProfileCard';

export default function AdminAccountProfile({ accountNumber }) {
  const [mutate] = useMutation(UPDATE_ACCOUNT_MUTATION);

  const save = async (_account, values) => {
    await mutate({ variables: { accountNumber, input: values } });
  };

  const sectionHomeRoute = generatePath(routes.admin.accountDetail.root, {
    accountNumber,
  });

  return (
    <AdminConsoleDetail
      query={ACCOUNT_QUERY}
      variables={{ accountNumber }}
      graphqlToForm={accountGraphqlToForm}
      formToGraphql={accountFormToGraphql}
      save={save}
      saveSuccessMessageId="admin.userManagement.accountDetail.save.success"
      getAfterSaveRedirectRoute={() => sectionHomeRoute}
      sectionHomeRoute={sectionHomeRoute}
      steps={[
        {
          path: routes.admin.accountDetail.root,
          routeProps: { exact: true },
          component: AdminAccountProfileCard,
          props: {
            sectionHomeRoute,
            formToGraphql: accountFormToGraphql,
          },
        },
      ]}
      getStepsProps={account => ({ account })}
    />
  );
}
